import { BalanceHistoryCommands } from 'src/store/shared/balance-history/types';
import type { BalanceHistoryState } from 'src/store/shared/balance-history/types';
import { initialEndDate, initialStartDate } from 'src/store/shared/balance-history/utils';
import { initialBalanceHistorySlice } from 'src/store/shared/balance-history/factory';
import { actionEsOnMessage } from '@skynet/data-ws-es';

export const initialState: BalanceHistoryState = {
  requestStatus: null,
  error: null,

  priceHistory: {},
  prices: {},
  regular: {},
  overrides: {},
  initialBalances: {},

  startDate: initialStartDate,
  startTime: '00:00',
  endDate: initialEndDate,
  endTime: 'current',

  // set initial balance
  isInitialBalanceModalOpen: false,
  formSetInitialBalance: undefined,
  resSetInitialBalance: null,
};

const { reducer, actions } = initialBalanceHistorySlice({
  prefix: 'trading',
  sliceName: 'balanceHistory',
  commands: BalanceHistoryCommands,
  messages: actionEsOnMessage,
  initialState,
});

export const BalanceHistoryActions = actions;

export default reducer;
